module.exports = __webpack_public_path__ + "static/media/apple.5465cc59.svg";